<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <div class="row">
            <div class="col text-right">
              Data
            </div>
          </div>
        </div>

        <div class="card-body park-team-body">
          <div class="p-4">
            <div class="row mb-3">
              <div class="col-4">
                <div class="row">
                  <div class="input-group">
                    <input
                      class="form-control"
                      ngbDatepicker
                      #fromDp="ngbDatepicker"
                      placeholder="From"
                      [ngModel]="fromDateStruct"
                      (ngModelChange)="onFromDateChange($event)"
                      (click)="fromDp.toggle()"
                      navigation="select"
                    />
                    <input
                      class="form-control"
                      ngbDatepicker
                      #toDp="ngbDatepicker"
                      placeholder="To"
                      [ngModel]="toDateStruct"
                      (ngModelChange)="onToDateChange($event)"
                      (click)="toDp.toggle()"
                      navigation="select"
                    />
                  </div>
                  <div class="row">
                    <div class="chart" style="position: relative; height: 40vh">
                      <canvas *ngIf="ShowRemedialPieChart"
                              id="RemedialSummary"
                              baseChart
                              [data]="remedialsPieChartData"
                              [type]="'pie'"
                              navigation="select"
                              [options]="remedialPieChart"
                              [plugins]="pieChartPlugins">
                      </canvas>

                      <h4 class="text-center mt-5" *ngIf="!ShowRemedialPieChart">No Remedials In The Selected Timeframe</h4>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-8 text-center">
                <h2>More Content Coming Soon!</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
